<template>
  <div id="app">
    <div id="lefter" class="pcs">
      <div class="float_center"><img src="./assets/images/xsh_logo.gif" width="231" height="22" alt="画家许四海的艺术空间" /></div>
      <img id="photo" src="./assets/images/xsh_photo.jpg" alt="画家许四海" />
      <p>　　许四海，中国国学院大学书法教研室主任、导师，大公国学书法院院长，华粹书画院院长，中国书法美术家协会副主席兼秘书长，中国美协会员，中国书协会员。</p><p>　　先后在北京军事博物馆、宋庄画家村，山东济南、日照、淄博、寿光，湖南长沙等地成功举办个展。被中央电视台、北京电视台、山东电视台、湖南电视台、人民网、中国军网、中国文化网、齐鲁网，《人民日报》、《解放军报》、《工人日报》、《中国文化报》、《法制日报》、《光明日报》、《中国书画报》、《华商报》、《中韩文化杂志》、《汽车杂志》等二十多家媒体进行了专访报道，出版有《许四海画集》、《2007许四海自选小品集》、《2009许四海自选作品集》、《清风雅韵——许四海工笔画集》、《当代实力派艺术家——许四海》、《赵体楷书免墨水写字帖》等著作。</p><p>联系电话：13651248826阿辉</p>
    </div>
    <div id="righter" class="index_bg">
	    <div id="nav">
        <router-link to="/index">首 页</router-link><span>|</span>
        <router-link to="/zuopin">作品展示</router-link><span>|</span>
        <router-link to="/pinglun">众评四海</router-link><span>|</span>
        <router-link to="/jiaoliu">艺术交流</router-link><span>|</span>
        <router-link to="/suiyue">岁月留痕</router-link><span>|</span>
        <router-link to="/message">访客留言</router-link><span>|</span>
        <router-link to="/huazhan" class="pcs">四海画展</router-link>
      </div>
      <router-view></router-view>
    </div>
	  <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* CSS Document */
body {
  font-family:"宋体", arial;
  text-align: center;
  margin:0;
  padding:0;
  background:#642905;
  font-size:12px;
  color:#fff;
  vertical-align: middle;
  height:100vh;
  SCROLLBAR-FACE-COLOR: #965229;
  SCROLLBAR-HIGHLIGHT-COLOR: #632905;
  SCROLLBAR-SHADOW-COLOR: #632905;
  SCROLLBAR-3DLIGHT-COLOR: #965229;
  SCROLLBAR-ARROW-COLOR: #632905;
  SCROLLBAR-DARKSHADOW-COLOR:#965229;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-items: center;

}

div,form,img,ul,ol,li,dl,dt,dd,p,h1,h2,h3,h4,h5,h6{border:0;padding:0;margin:0;}
table,td,tr,th{font-size:12px;}
li{list-style-type: none;}
img{vertical-align:top;}
/* 链接颜色 */
a{cursor: pointer;}
a:link {color: #fff; text-decoration:none;}
a:visited {color: #fff;text-decoration:none;}
a:hover {color: #FEFFA7; text-decoration:underline;}
a:active {color: #fff;}
.clear{clear:both;}

.xRed{color:#CF0D11;}
.aRed,a.aRed:link,a.aRed:visited{ color:#C00;text-decoration:none;}
a.aRed:hover {color:#CF0D11; text-decoration:underline;}
.cRed,a.cRed:link,a.cRed:visited{ font-size:12px;font-weight:bold;color:#883424;text-decoration:none;}
a.cRed:hover {font-size:12px;font-weight:bold;color:#883424;text-decoration:underline;}
.cblue,a.cblue:link,a.cblue:visited{ color:#03C;text-decoration:underline;}
a.cblue:hover {color:#03C; text-decoration:none;}

.blank9{ height:9px;clear:both;font-size:1px;line-height:1px;overflow:hidden;}
.float_left{float:left;}
.float_center{margin:0 auto;text-align:center;}
.float_right{float:right;}
.HackBox{display:none;}

/* CSS Document */
#app{width:1003px;background:#965229 url(./assets/images/xsh_bg_line.gif) repeat-y 320px 0px;overflow:hidden;display:inline-block; *display:inline; *zoom:1;clear:both;}

#lefter{width:290px;padding:10px 15px;float:left;}
#photo{margin:10px 0 2px 0;padding:5px;background:#fff;width:280px;height:200px;}
#lefter p{line-height:18px;text-align:justify;padding-top: 10px;}

#righter{float:right;width:683px;height:593px;position:relative;}
#nav{border:1px solid #080502;background: url(./assets/images/xsh_nav_bg.gif) repeat-x left top; width:670px;height:30px;text-align:left;padding-top:7px;padding-left:11px;}
#nav span{width:10px;float:left;text-align:center;line-height:19px;}
#nav a{width:70px;height:25px;float:left;padding-top:2px;text-align:center;line-height:18px;}
#nav a:hover,#nav a.router-link-active{background:url(./assets/images/xsh_menu_bg.gif) no-repeat center top;color:#000;font-weight:bold;text-decoration:none;}

.hzlist{margin-top:40px;}
.hzlist a{padding:10px 20px 10px 20px;font-weight:bold;margin:0 10px;border:2px solid #FEFFA7;color: #fff; text-decoration: none;cursor: pointer;}
.hzlist a.over{background-color:#FEFFA7;color:#000;}


#junbo{padding:10px 0;height:534px;overflow-y:auto;}
#junbo ul {margin-top:5px;clear:both;}
#junbo li {margin-left:10px;display:inline;float:left;height:118px;overflow:hidden;line-height:14px;}
#junbo li img{padding:3px;background:#fff;}
#junbo li a:hover img{border:#8E4A0B;background:#FFF1A2;}

#pinglun{padding: 0 15px; margin-top: -15px;}
#pinglun li {height:108px;overflow:hidden; border-bottom:1px dotted #fff;padding:10px 0;text-align:left;}
#pinglun .nobottom {border-bottom:none;}
#pinglun li img {padding:3px;border:1px solid #E6E6E6;background:#fff;float:left;margin-right:15px;}
#pinglun li a:hover img{border:#8E4A0B;background:#FFF1A2;}
#pinglun li a,#pinglun li a:visited{color:#FFF; }
#pinglun li a:hover{text-decoration: underline;}
#pinglun li h1{line-height:21px; padding-bottom: 6px;}
#pinglun li p{line-height:20px;text-indent:2em;padding-right:10px;text-align:justify;text-justify:distribute;}
#pinglun li h1 a,#pinglun li h1 a:visited{color:#FFF;font-size:14px;font-weight:bold;}
#pinglun li h1 a:hover{text-decoration: underline;}

#pinglunshow{padding:20px;height:516px;overflow:auto;}
#pinglunshow h1{font-size:16px;}
.pinglunpic{padding-top:15px;text-align:center;line-height:25px;}
.pinglunpic img{padding:3px;border:1px solid #E6E6E6;background:#fff;}
.article{text-align:left;text-align:justify;text-justify:distribute;line-height:21px;padding:8px 10px;}
#pinglunshow .back{padding-top:15px;height:50px;}

#page{left:5px;position:absolute;bottom:3px;border-top:1px dotted #fff;clear:both;width:673px;line-height:30px;}
#contact{width:526px;height:217px; background:url(./assets/images/xsh_contact.jpg) center top;margin:100px auto;}
#contact p{line-height:21px;text-align:left;padding:25px 0 0 215px;}

#message{padding:70px 40px; text-align:left;color:#000;}

#image_wrap{width:632px;background:#fff;TEXT-ALIGN:center;margin:18px auto 10px auto;border:5px solid #fff;}
.hyly_conter{height:102px;width:642px;margin:0 auto;text-align:left;}
#marquee1 {overflow:hidden;width:642px;heigth:102px;position:absolute;}
#marquee1 ul li{padding:0 5px;float:left;display:inline;}
#marquee1 li img{padding:3px;background:#fff;}
#marquee1 li a:hover img{padding:3px;background:#FFF1A2;}
.ov{height:534px;margin:20px 0;overflow-y: auto;}

.items li {margin-left:32px;display:inline;float:left; overflow:hidden;}
.items li a,.items li a:visited{color:#FEFFA7; }
.items li a:hover{font-weight:bold;text-decoration:none;}
.items li img{padding:3px;border:1px solid #E6E6E6;background:#fff;}
.items li a:hover img{border-color:#8E4A0B;background:#FFF1A2;}
.items.fang li a { display: flex;align-content: center;
    justify-content: center;
    background: #fff;
    align-items: center;
    padding:3px;border:1px solid #E6E6E6;background:#fff; width: 124px; height: 124px;margin-bottom: 30px;}
.items.fang li img { max-width: 100%; max-height: 100%;padding: 0;border: none;}
.items.chang li img { width: 148px; height: 110px;margin-bottom: 4px;}
.items.chang li { margin-left:11px;display:inline;float:left;width:156px; height:168px; line-height:14px;}
.pcs {}
.mbs {display: none;}
@media (max-width: 1000px) {
  .pcs {display: none;}
  .mbs {display: block;}
  body {display: block;padding-top: 39px; background: #965229;}
  #app {width: 100%; background: #965229;}
  #nav {position: fixed; top: 0; left: 0; width: 100%; padding-left: 0; text-align: center;display: flex;justify-content: space-evenly;}
  #nav a{width: 60px; float: none;}
  #nav span{display: none;}
  #righter{float:none;width:100%;height:auto;}
  .ov{height:auto;}

  #pinglun li {height:auto;overflow:hidden; }
  .items {display: flex; flex-wrap: wrap; justify-content: space-evenly;}
  .items li {margin:0px;}
  .items.chang li { margin-left: 0;}
  /* .items.fang li img { margin: 20px;} */
}
</style>
